export default "__VITE_ASSET__CJ2zI$HM__"